import { EdgeData } from "@features/builder/graph/types"
import { EditRoomLocksMember } from "@features/builder/hooks/socketIOHooks"
import useNodeLock from "@features/builder/hooks/useNodeLock"
import { Edge, useEdges } from "@xyflow/react"
import { useMemo } from "react"

export const useEdgeLock = (edgeId: string): EditRoomLocksMember | undefined => {
  const edges = useEdges<Edge<EdgeData>>()
  const edge = useMemo(() => edges.find((edge) => edge.id === edgeId), [edgeId, edges])

  const sourceNodeLock = useNodeLock({ nodeId: edge?.data?.finalSource ?? "" })
  const targetNodeLock = useNodeLock({ nodeId: edge?.data?.finalTarget ?? "" })

  return sourceNodeLock ?? targetNodeLock
}
